import { FunctionComponent, useEffect, useState } from "react";

import fcke from "../../assets/svg/fcke.svg";
import kfa from "../../assets/svg/kfa.svg";
import roznava from "../../assets/svg/roznava.svg";
import aquareina from "../../assets/svg/aquareina.svg";
import urbanfest from "../../assets/svg/urbanfest.svg";
import { useTranslation } from "../../TranslationContext";

const Metrics: FunctionComponent = () => {
  const translations = useTranslation();
  const [badges, setBadges] = useState(100000);
  const [experience, setExperience] = useState(5);

  useEffect(() => {
    const startBadges = new Date(2023, 10, 1); // November 1, 2023
    const startExperience = new Date(2002, 0, 1); // November 1, 2002

    const updateMetrics = () => {
      const now = new Date();

      // Update experience
      if (now >= startExperience) {
        const yearsPassed = Math.floor(
          (now.getTime() - startExperience.getTime()) /
            (1000 * 60 * 60 * 24 * 365)
        );
        setExperience(yearsPassed);
      }
    };

    const intervalId = setInterval(updateMetrics, 1); // Update every second
    return () => clearInterval(intervalId); // Clean up on component unmount
  }, []);

  return (
    <div className="relative bg-whitew-full flex flex-col items-center justify-center">
      <div
        id="metrics"
        className="relative bg-black w-full flex flex-row py-16 px-20 items-center justify-center text-center text-5xl text-gray-200 font-text-xl-font-medium sm:text-4xl xs:px-6"
      >
        <div className="flex flex-row w-full max-w-[1340px] items-stretch justify-around lg:flex-col lg:gap-12">
          <div className="flex flex-col py-0 px-10 items-center justify-center">
            <div className="relative leading-[150%] font-extrabold text-gradient">
              {translations.metrics.dailyMeters.value}
            </div>
            <div className="relative leading-[150%] font-medium text-2xl sm:text-xl">
              {translations.metrics.dailyMeters.label}
            </div>
          </div>
          <div className="flex flex-col py-0 px-10 items-center justify-center">
            <div className="relative leading-[150%] font-extrabold text-gradient">
              {translations.metrics.printedMeters.value}
            </div>
            <div className="relative leading-[150%] font-medium text-2xl sm:text-xl">
              {translations.metrics.printedMeters.label}
            </div>
          </div>
          <div className="flex flex-col py-0 px-10 items-center justify-center">
            <div className="relative leading-[150%] font-extrabold text-gradient">
              {experience} +
            </div>
            <div className="relative leading-[150%] font-medium text-2xl sm:text-xl">
              {translations.metrics.yearsOfExperience.label}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Metrics;
